export type { ClientEnvironment, GlobalConfig } from './globalConfig'
export { getGlobalEnvironmentConfig } from './globalConfig'
export { ClientEnvironmentContext } from './clientEnvironmentContext'
